import cn from 'classnames/bind'

import styles from './header3.module.scss';


const cx = cn.bind(styles)

type Props = {
  children: React.ReactNode
  className?: string
  skipMargin?: boolean
  wide?: boolean
}

const Header3 = ({ children, className, skipMargin, wide = true }: Props) => {
  return (
    <h3 className={cx(styles.header2, className, { skipMargin, wide })}>
      {children}
    </h3>
  )
}

export default Header3
